import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  HostListener,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

import { IInboxJob } from '../../../interfaces/inbox-job';
import { IInboxJobFilter } from '../../../interfaces/inbox-job-filter';
import { EventService } from '../../../services';
import { InboxJobsService } from '../../../services';
import { SupplierInboxJobsService } from '../../../services';
import { InputHelper } from '../../../utils/input.helper';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import { Subscription } from 'rxjs';
import { GoogleAnalyticsService } from '../../../services';
import { SupplierJobStoreService } from '../../../services';
import { SupplierJobInteractionService } from '../../../services';
import { Message } from 'src/app/classes/Message';
import { SupplierJobChannel } from '../../../enums/supplier-job-channel';
import { HttpErrorResponse } from '@angular/common/http';
import { SupplierInboxType } from '../../../enums/supplier-inbox.type.enum';

@Component({
  selector: 'supplier-jobs-card',
  templateUrl: './supplier-jobs-card.component.html',
  styleUrls: ['./supplier-jobs-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SupplierJobsCardComponent implements OnInit, AfterViewInit, OnDestroy {
  taskTypes: SelectItem[] = [this.inboxJobsService.taskTypeDefSelect];

  public selectedJob: IInboxJob;

  @Input() supplierJobChannel: SupplierJobChannel;

  @Input() googleAnalyticsEventLabel: string;

  private subscriptions: Subscription[] = [];

  constructor(
    private inboxJobsService: InboxJobsService,
    private supplierInboxJobsService: SupplierInboxJobsService,
    public messageService: MessageService,
    public inputHelper: InputHelper,
    public supplierJobStoreService: SupplierJobStoreService,
    private supplierJobInteractionService: SupplierJobInteractionService,
    private confirmationService: ConfirmationService,
    private eventService: EventService,
  ) {
    const sub = this.eventService.JobRejectionEvent.subscribe((e) => {
      if (e.action == 'jobWatching') {
        this.supplierJobStoreService.setJobWatching(e.jobId, true);
      }
      if (e.action == 'jobUnwatching') {
        this.supplierJobStoreService.setJobWatching(e.jobId, false);
      }
    });

    this.subscriptions.push(sub);
  }

  private _inboxType: SupplierInboxType;

  get inboxType(): SupplierInboxType {
    return this._inboxType;
  }

  @Input('inboxType')
  set inboxType(value: SupplierInboxType) {
    this._inboxType = value;
  }

  _filterVal: IInboxJobFilter;

  @Input()
  set filterVal(value: IInboxJobFilter) {
    this._filterVal = value;

    if (this._filterVal?.filters?.inboxType) {
      this._filterVal.filters.inboxType.value = this._inboxType;
    }

    if (value != null && Object.keys(value).length !== 0) {
      this.supplierJobStoreService.getPage(this._filterVal, true);
    }
  }

  get filterVal() {
    return this._filterVal;
  }

  ngOnInit() {}

  changedVisibility(isVisible: boolean, jobId: number) {
    if (!isVisible) {
      return;
    }

    this.supplierJobStoreService.getNextPageIfRequired(this.filterVal, jobId);
  }

  ngAfterViewInit() {}

  reload() {
    this.supplierJobStoreService.getPage(this.filterVal, true);
  }

  handBackJob(jobId: number) {
    this.confirmationService.confirm({
      header: 'Hand back Job',
      message: `Are you sure you want to hand back this job?`,
      accept: () => {
        this.supplierInboxJobsService
          .supplierHandBack(jobId)
          .then((res) => {
            this.messageService.add(Message.Success('', 'Hand back successful'));
            this.supplierJobStoreService.removeJob(jobId);
            this.supplierJobInteractionService.logSingleJobInteraction(
              'RemoveJobFromSupplierSuccess',
              jobId,
              {},
            );
          })
          .catch((err: HttpErrorResponse) => {
            if (err.status == 422) {
              this.messageService.add(Message.Error(err.error, 'Hand Back Error'));
            } else {
              this.messageService.add(
                Message.Error(
                  'An unknown error occurred, please contact Engineius',
                  'Hand Back Error',
                ),
              );
            }
          });
      },
    });
  }

  @HostListener('window:resize', ['$event'])
  sizeChange() {
    window.setTimeout(() => {
      // prime-ng carousel does not recalculate width of carousel items on windows resize
      let carouselElements = $('.ui-carousel:visible');
      let setWidth = carouselElements.first().outerWidth() - 2;
      if (carouselElements.length > 0 && setWidth > 0)
        carouselElements
          .find('.ui-carousel-item')
          .css('width', carouselElements.first().outerWidth() - 2);
    }, 1000);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s?.unsubscribe());
  }
}
